"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.BmInputInfo = exports.defaultPlaceHolder = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _itemFactory = require("../item-engine/item-factory");

var _bmFormValues = require("../../bm-form-values");

var defaultPlaceHolder = '- - -';
exports.defaultPlaceHolder = defaultPlaceHolder;

var BmInputInfo = /*#__PURE__*/function (_bmValuedField) {
  (0, _inherits2.default)(BmInputInfo, _bmValuedField);

  var _super = (0, _createSuper2.default)(BmInputInfo);

  function BmInputInfo(inputItemInfo, parent, val) {
    var _this;

    (0, _classCallCheck2.default)(this, BmInputInfo);
    _this = _super.call(this, inputItemInfo, parent);
    _this.options = void 0;
    _this.previouslyDisabled = false;
    _this.disabled = false;
    _this.previouslyReadonly = false;
    _this.readonly = false;
    _this.touched = false;
    _this.dirty = false;
    _this.initial = void 0;
    _this.value = void 0;
    _this.hideErrors = false;
    _this.previousHideErrors = null;
    _this.options = inputItemInfo.options;
    _this.initial = val;
    _this.value = val;

    if (inputItemInfo.options.readonly === true) {
      _this.readonly = true;
    }

    return _this;
  }

  return BmInputInfo;
}((0, _bmFormValues.bmValuedField)(_itemFactory.BmItemInfo));

exports.BmInputInfo = BmInputInfo;
